module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', {
    attrs: {
      "collapsible": ""
    }
  }, [_c('p', {
    slot: "header"
  }, [_vm._v("\n        Filtry\n    ")]), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "E-mail",
      "name": "name",
      "type": "text",
      "placeholder": "Wpisz część adresu e-mail"
    },
    on: {
      "input": _vm.filter
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _vm._v(" "), _c('i-select', {
    attrs: {
      "name": "groups",
      "label": "Grupy",
      "options": _vm.groups,
      "placeholder": "Wybierz",
      "help-text": "E-maile które występują w przynajmniej jednej z zaznaczonych grup"
    },
    on: {
      "input": _vm.filter
    },
    model: {
      value: (_vm.groups_ids),
      callback: function($$v) {
        _vm.groups_ids = $$v
      },
      expression: "groups_ids"
    }
  }), _vm._v(" "), _c('i-select', {
    attrs: {
      "name": "status",
      "label": "Status",
      "options": _vm.statuses,
      "placeholder": "Wybierz status"
    },
    on: {
      "input": _vm.filter
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }), _vm._v(" "), _c('ui-button', {
    on: {
      "click": _vm.filter
    }
  }, [_vm._v("Filtruj")]), _vm._v(" "), _c('ui-button', {
    on: {
      "click": _vm.removeFilter
    }
  }, [_vm._v("Usuń filtry")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-667518ff","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/emails/Filters.vue
// module id = 267
// module chunks = 0